<app-advanced-form [config]="advancedFormConfig"
                   (events)="onAdvancedFormEvents($event)"
                   [mmTestId]="'CHANGE_PASSWORD_PAGE.FORM'"></app-advanced-form>
